<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('signRecord.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="signRecordInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input
              v-model="signRecordInfo.conditions.personName"
              :placeholder="$t('signRecord.placeholder.personName')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="signRecordInfo.conditions.personId"
              :placeholder="$t('signRecord.placeholder.personId')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="signRecordInfo.conditions.signDate"
              :placeholder="$t('signRecord.placeholder.signDate')"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_querySignRecordMethod">
              <i class="el-icon-search"></i>
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('signRecord.title') }}</div>
      </div>
      <div class="">
        <el-table
          :data="signRecordInfo.signRecords"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="recordId"
            :label="$t('signRecord.table.recordId')"
            align="center"
          />
          <el-table-column
            prop="accountId"
            :label="$t('signRecord.table.accountId')"
            align="center"
          />
          <el-table-column
            prop="personId"
            :label="$t('signRecord.table.personId')"
            align="center"
          />
          <el-table-column
            prop="personName"
            :label="$t('signRecord.table.personName')"
            align="center"
          />
          <el-table-column
            prop="signDate"
            :label="$t('signRecord.table.signDate')"
            align="center"
          />
          <el-table-column
            prop="signType"
            :label="$t('signRecord.table.signType')"
            align="center"
          />
          <el-table-column
            prop="rewardAmount"
            :label="$t('signRecord.table.rewardAmount')"
            align="center"
          />
          <el-table-column
            prop="rewardDesc"
            :label="$t('signRecord.table.rewardDesc')"
            align="center"
          />
          <el-table-column
            prop="remark"
            :label="$t('signRecord.table.remark')"
            align="center"
          />
          <el-table-column
            prop="createTime"
            :label="$t('signRecord.table.createTime')"
            align="center"
          />
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="signRecordInfo.conditions.page"
          :page-size="signRecordInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="signRecordInfo.total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySignRecord } from '@/api/admin/sign/signRecordApi'

export default {
  name: 'SignRecord',
  data() {
    return {
      signRecordInfo: {
        signRecords: [],
        total: 0,
        records: 1,
        conditions: {
          page: 1,
          row: 10,
          personId: '',
          personName: '',
          signDate: '',
          statusCd: '0'
        }
      }
    }
  },
  created() {
    this._listSignRecords()
  },
  methods: {
    async _listSignRecords(page = 1, rows = 10) {
      this.signRecordInfo.conditions.page = page
      this.signRecordInfo.conditions.row = rows
      try {
        const res = await querySignRecord(this.signRecordInfo.conditions)
        this.signRecordInfo.signRecords = res.data || []
        this.signRecordInfo.total = res.total || 0
        this.signRecordInfo.records = res.records || 0
      } catch (error) {
        console.error(error)
      }
    },
    _querySignRecordMethod() {
      this._listSignRecords()
    },
    handleCurrentChange(val) {
      this._listSignRecords(val, this.signRecordInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ibox-title {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  min-height: 16px;
}
.ibox-content {
  padding: 20px;
}
</style>
